export const GET_ALL_POSTS_START = 'GET_ALL_POSTS_START';
export const GET_ALL_POSTS_SUCCESS = 'GET_ALL_POSTS_SUCCESS';
export const GET_ALL_POSTS_FAILURE = 'GET_ALL_POSTS_FAILURE';

export const GET_ALL_POSTS_ADMIN_START = 'GET_ALL_POSTS_ADMIN_START';
export const GET_ALL_POSTS_ADMIN_SUCCESS = 'GET_ALL_POSTS_ADMIN_SUCCESS';
export const GET_ALL_POSTS_ADMIN_FAILURE = 'GET_ALL_POSTS_ADMIN_FAILURE';

export const ADD_POST_START = 'ADD_POST_START';
export const ADD_POST_SUCCESS = 'ADD_POST_SUCCESS';
export const ADD_POST_FAILURE = 'ADD_POST_FAILURE';

export const CHANGE_POST_STATUS_START = 'CHANGE_POST_STATUS_START';
export const CHANGE_POST_STATUS_SUCCESS = 'CHANGE_POST_STATUS_SUCCESS';
export const CHANGE_POST_STATUS_FAILURE = 'CHANGE_POST_STATUS_FAILURE';

export const DELETE_POST_START = 'DELETE_POST_START';
export const DELETE_POST_SUCCESS = 'DELETE_POST_SUCCESS';
export const DELETE_POST_FAILURE = 'DELETE_POST_FAILURE';

export const GET_POST_DETAILS_START = 'GET_POST_DETAILS_START';
export const GET_POST_DETAILS_SUCCESS = 'GET_POST_DETAILS_SUCCESS';
export const GET_POST_DETAILS_FAILURE = 'GET_POST_DETAILS_FAILURE';

export const EDIT_POST_DETAILS_START = 'EDIT_POST_DETAILS_START';
export const EDIT_POST_DETAILS_SUCCESS = 'EDIT_POST_DETAILS_SUCCESS';
export const EDIT_POST_DETAILS_FAILURE = 'EDIT_POST_DETAILS_FAILURE';
export const EDIT_POST_DETAILS_RESET = 'EDIT_POST_DETAILS_RESET';
